import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Transform, Type } from "class-transformer";
import { WarehouseDto } from "@/core/features/warehouses/warehouse.dto";
import { UserDto } from "@/core/features/users/user.dto";
import { WarehouseStatusEnum } from "@altertec_gparn/lib";

export class LocationDto extends BaseEntityDto {
  name: string;

  @Transform(({ value }) => (value ? WarehouseStatusEnum.OPEN : WarehouseStatusEnum.CLOSED))
  isOpen: WarehouseStatusEnum;

  @Type(() => WarehouseDto)
  warehouse: WarehouseDto;
  warehouseId: string;

  @Type(() => UserDto)
  createdBy: UserDto;

  @Type(() => UserDto)
  updatedBy: UserDto;

  toString() {
    return this.name;
  }
}
